import { render, staticRenderFns } from "./AdminReport.vue?vue&type=template&id=63d396d2&scoped=true&"
import script from "./AdminReport.vue?vue&type=script&lang=js&"
export * from "./AdminReport.vue?vue&type=script&lang=js&"
import style0 from "./AdminReport.vue?vue&type=style&index=0&id=63d396d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63d396d2",
  null
  
)

export default component.exports